$(function() {
    setTimeout(function() {
        var popular_car =  $('.popular-cars');
        popular_car.slick({
                dots: false,
                arrow: true,
                focusOnSelect: true,
                infinite: false,
                speed: 500,
                slidesToShow: 3.6,
                slidesToScroll: 1,
                touchThreshold: 5,
                prevArrow: '<button class="slide-arrow prev-arrow"><i class="fa-solid fa-chevron-left"></i></button>',
                nextArrow: '<button class="slide-arrow next-arrow"><i class="fa-solid fa-angle-right"></i></button>',
                responsive: [
                {
                    breakpoint: 991,
                    settings: {
                    slidesToShow: 2.8,
                    arrow:false,
                    }
                },
                {
                    breakpoint: 767,
                    settings: {
                    slidesToShow: 2.1,
                    arrow:false,
                    }
                },
            ]
        });
    }, 500);
});
